'use client';
import styled from 'styled-components';
import { IconButton } from '../IconButton';
import { Input as BaseInput } from '../Input';
import { TypeStyle } from '../TypeStyle';
const horizontalPadding = 20;
const buttonSize = 40;
export const Form = styled.form `
  position: relative;
`;
export const Input = styled(BaseInput) `
  ${TypeStyle.css.headlineExtraExtraSmall}
  background-color: ${o => o.theme.color.fill.background};
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.interaction.secondary.on.background};
  border-radius: 4px;
  box-sizing: border-box;
  color: ${o => o.theme.color.text.primary.on.background};
  display: block;
  height: ${buttonSize}px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-inline-start: ${horizontalPadding}px;
  padding-inline-end: ${buttonSize + horizontalPadding}px;
  width: 100%;

  &:focus {
    border-color: ${o => o.theme.color.stroke.neutral.border.interaction.primary.on.background};
  }

  ::placeholder {
    color: ${o => o.theme.color.text.secondary.on.background};
  }
`;
export const Button = styled.button `
  display: block;
  height: ${buttonSize}px;
  position: absolute;
  inset-inline-end: 0;
  top: 0;
  width: ${buttonSize}px;
`;
export const IconWrapper = styled(IconButton) `
  display: flex;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;
//# sourceMappingURL=styles.js.map